import { render, staticRenderFns } from "./AppMenuList.vue?vue&type=template&id=d32cfe66&scoped=true&"
import script from "./AppMenuList.vue?vue&type=script&lang=ts&"
export * from "./AppMenuList.vue?vue&type=script&lang=ts&"
import style0 from "./AppMenuList.vue?vue&type=style&index=0&id=d32cfe66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32cfe66",
  null
  
)

export default component.exports